import React, { useState } from 'react';
import PageTableLayout from '../components/PageTableLayout';

const breadcrumb = (
  <span>
    Home &nbsp;/&nbsp; Webber &nbsp;/&nbsp; <span className="text-gray-700">Downloads</span>
  </span>
);

const columns = [
  { key: 'title', title: 'Title' },
  { key: 'file', title: 'File' },
  { key: 'status', title: 'Status' },
];

const mockData = [
  { id: 1, title: 'Prospectus', file: 'prospectus.pdf', status: 'Active' },
  { id: 2, title: 'Holiday List', file: 'holiday-list.pdf', status: 'Active' },
];

const Downloads = () => {
  const [data, setData] = useState(mockData);
  const filters = [
    <input key="title" className="border px-2 py-1 rounded text-sm" placeholder="Enter title" />,
    <input key="file" className="border px-2 py-1 rounded text-sm" placeholder="Enter file name" />,
    <select key="status" className="border px-2 py-1 rounded text-sm">
      <option>Select Status</option>
      <option>Active</option>
      <option>Inactive</option>
    </select>,
    <button key="filter" className="bg-blue-600 text-white px-3 py-1 rounded text-xs">Filter</button>
  ];
  const handleEdit = (row) => alert(`Edit: ${row.title}`);
  const handleAddNew = () => alert('Add New Download');
  return (
    <PageTableLayout
      title="Downloads"
      breadcrumb={breadcrumb}
      columns={columns}
      data={data}
      filters={filters}
      onEdit={handleEdit}
      onAddNew={handleAddNew}
    />
  );
};

export default Downloads;
